import React from 'react';
import { CategoryTable } from './CategoryTable';
import { GetCategoriesUsageLazyQueryHookResult } from '../../../../models/graphql';
import { ChartPanel } from '../../ChartPanel';

type CategoryUsageViewProps = {
  loading: boolean;
  data: GetCategoriesUsageLazyQueryHookResult[1]['data'];
};
export const CategoryUsageView = ({ loading, data }: CategoryUsageViewProps) => {
  return (
    <ChartPanel
      loading={loading}
      chartTitle={'Category Usage'}
      chartSubtitle={'Which Categories did you publish to the most, and which got the most engagement'}
      subTitleTooltipText={'The metrics show the average engagement per post.'}
      isEmpty={false}>
      <CategoryTable data={data} />
    </ChartPanel>
  );
};
